/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useState, useEffect, useRef } from 'react'
import { toast } from 'react-toastify'
import Pagination from 'react-bootstrap/Pagination'
import Table from 'react-bootstrap/Table'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import { Col, Dropdown, Modal, Row, Spinner } from 'react-bootstrap'

// Hooks
import useServices from 'utils/hooks/useServices'
import useDebounce from 'utils/hooks/useDebounce'
import usePagination from 'utils/hooks/usePagination'

// Helpers
import FormGenerator from 'utils/helpers/FormGenerator'

// API Service...
import MasterServices from 'services/master'

// Layouts...
import { PageTitle } from '_metronic/layout/core'

// Initial..
const heads = [
    {
        name: '',
        label: 'Judul',
    },
    {
        name: '',
        label: 'Tipe',
    },
    {
        name: '',
        label: 'Kategori',
    },
    {
        name: '',
        label: 'Publikasi',
    },
    {
        name: '',
        label: 'Status',
    },
    {
        name: '',
        label: 'Aksi',
    },
]

const COPNewsPage: FC = () => {
    const [inputFields, setInputFields] = useState([
        {
            name: 'upload_thumbnail',
            label: 'Upload Thumbnail',
            type: 'file',
            validation: {},
            col: 12,
            options: [],
            additional: '',
            // additional option for file type
            accept: 'image/*',
        },
        {
            name: 'upload_dokumen',
            label: 'Upload Dokumen',
            type: 'file',
            validation: {},
            col: 12,
            options: [],
            additional: '',
            // additional option for file type
            accept: 'application/pdf',
        },
        {
            name: 'Tipe',
            label: 'Tipe',
            type: 'select',
            validation: {},
            col: 12,
            additional: '',
            getItemValue: 'name',
            getItemValueId: 'value',
            options: [
                {
                    name: '',
                    value: '',
                },
                {
                    name: 'CoP',
                    value: 'COP',
                },
                {
                    name: 'Berita',
                    value: 'Berita',
                },
            ],
        },
        {
            name: 'kategori_berita_id',
            label: 'Kategori',
            type: 'select',
            validation: {},
            col: 12,
            options: [],
            additional: '',
            getItemValue: 'name',
            getItemValueId: 'value',
        },
        {
            name: 'judul',
            label: 'Judul Artikel',
            type: '',
            validation: {},
            col: 12,
            options: [],
            additional: '',
        },
        {
            name: 'abstrak',
            label: 'Abstrak',
            type: 'rich-text',
            validation: {},
            col: 12,
            options: [],
            additional: '',
        },
        {
            name: 'link_youtube',
            label: 'Youtube ID',
            type: '',
            validation: {},
            col: 12,
            options: [],
            additional: '',
        },
        {
            name: 'is_highlight',
            label: 'Highlight',
            type: 'select',
            validation: {},
            col: 12,
            options: [
                {
                    name: '',
                    value: '',
                },
                {
                    name: 'Ya',
                    value: '1',
                },
                {
                    name: 'Tidak',
                    value: '0',
                },
            ],
            additional: '',
            getItemValue: 'name',
            getItemValueId: 'value',
        },
        {
            name: 'urutan',
            label: 'Urutan',
            type: 'number',
            validation: {},
            col: 12,
            options: [],
            additional: '',
        },
        {
            name: 'is_active',
            label: 'Status',
            type: 'select',
            validation: {},
            col: 12,
            options: [
                {
                    name: '',
                    value: '',
                },
                {
                    name: 'Aktif',
                    value: '1',
                },
                {
                    name: 'Non-Aktif',
                    value: '0',
                },
            ],
            getItemValue: 'name',
            getItemValueId: 'value',
            additional: '',
        },
    ])
    const [pagination, setPagination] = useState({
        per_page: 10,
        page: 1,
        total_page: 1,
        total_page_arr: [1, 2, 3, 4, 5],
        total_row: 10,
    })
    const [isEdit, setIsEdit] = useState(false)
    const [show, setShow] = useState(false)
    const [query, setQuery] = useState<any>({q: '', sort_order: 'desc'})
    const [formValue, setFormValue] = useState<any>({})
    const [submit, setSubmit] = useState(false)

    const [data, loading, empty, refresh, isError, setLoading] = useServices(
        MasterServices.getCOPNews,
        {...query, page: pagination.page, sort_field: 'created_at', per_page: pagination.per_page},
        []
    )

    const [categories, categoriesLoading, categoriesEmpty, categoriesRefresh, categoriesIsError, categoriesSetLoading] = useServices(
        MasterServices.getCOPCategoryNoHash,
        {...query, page: pagination.page, sort_field: 'created_at', per_page: pagination.per_page},
        []
    )

    const paginator: any = usePagination({
        totalCount: data?.data?.total,
        pageSize: pagination.per_page || 10,
        currentPage: pagination.page || 1,
    })

    const categoriesLoadedRef = useRef(false)

    // Effect for pagination changes
    useEffect(() => {
        refresh()
        generateTotalPage(pagination.total_page)
    }, [pagination.per_page, pagination.page])
    
    // Separate effect for categories
    useEffect(() => {
        // Only fetch categories once
        if (!categoriesLoadedRef.current) {
            categoriesRefresh()
            categoriesLoadedRef.current = true
        }
    }, [])
    
    // Effect to update inputs when categories change
    // useEffect(() => {
    //     if (categories?.data?.data && categories.data.data.length > 0) {
    //         const formattedCategories = categories.data.data.map((category: any) => ({
    //             name: `${category.tipe_kategori} - ${category.nama_kategori}`,
    //             value: category.id
    //         }))
            
    //         setInputFields(prevInputs => {
    //             const newInputs = [...prevInputs]
    //             const categoryIndex = newInputs.findIndex(input => input.name === 'kategori_berita_id')
                
    //             if (categoryIndex !== -1) {
    //                 newInputs[categoryIndex] = {
    //                     ...newInputs[categoryIndex],
    //                     options: formattedCategories
    //                 }
    //             }
                
    //             return newInputs
    //         })
    //     }
    // }, [categories])

    useDebounce(refresh, 250, [query.q, query.sort_order])

    const toggle = () => {
        if (show) {
            setFormValue({})
        }
        
        setShow(!show)
    }
    
    const generateTotalPage = (totalPage: number) => {
        let total = 0
        let newTotal: any = []

        for (total = 0; total < totalPage; total++) {
            if (total < 4) {
                newTotal.push(total + 1)
            } else if (total === 8) {
                newTotal.push('...')
                newTotal.push(totalPage)
            }
        }
        return newTotal
    }
    
    const onChangePerPage = (per_page: number, to_page = 1) => {
        setPagination({
            ...pagination,
            per_page: per_page,
            page: to_page || 1,
        })
    }
    
    const onChange = async (e: any) => {
        const {name, value} = e.target
        let updatedFormValue = {
            ...formValue,
            [name]: value,
        }

        // Handle type selection to set is_berita and is_blog
        if (name === 'Tipe') {
            if (value === 'Berita') {
                updatedFormValue.is_berita = '1'
                updatedFormValue.is_blog = '0'

                // start fetch categories berita witha add parameters tipe_kategori = Berita
                const categoriesBerita = await MasterServices.getCOPCategoryNoHash({tipe_kategori: value})
                const mappedCategories = categoriesBerita?.data?.data?.map((category: any) => ({
                    name: `${category.tipe_kategori} - ${category.nama_kategori}`,
                    value: category.id
                })) || []
                
                setInputFields(prevInputs => {
                    const newInputs = [...prevInputs]
                    const categoryIndex = newInputs.findIndex(input => input.name === 'kategori_berita_id')
                    if (categoryIndex !== -1) {
                        // clear options
                        newInputs[categoryIndex].options = []
                        newInputs[categoryIndex] = {
                            ...newInputs[categoryIndex],
                            options: mappedCategories
                        }
                    }
                    return newInputs
                })
                
                // Auto-select first category if available
                if (mappedCategories.length > 0 && mappedCategories[0].value) {
                    updatedFormValue.kategori_berita_id = mappedCategories[0].value
                }
            } else if (value === 'COP') {
                updatedFormValue.is_berita = '0'
                updatedFormValue.is_blog = '1'

                // start fetch categories blog witha add parameters tipe_kategori = COP
                const categoriesBlog = await MasterServices.getCOPCategoryNoHash({tipe_kategori: value})
                const mappedCategories = categoriesBlog?.data?.data?.map((category: any) => ({
                    name: `${category.tipe_kategori} - ${category.nama_kategori}`,
                    value: category.id
                })) || []
                
                setInputFields(prevInputs => {
                    const newInputs = [...prevInputs]
                    const categoryIndex = newInputs.findIndex(input => input.name === 'kategori_berita_id')
                    if (categoryIndex !== -1) {
                        // clear options
                        newInputs[categoryIndex].options = []
                        newInputs[categoryIndex] = {
                            ...newInputs[categoryIndex],
                            options: mappedCategories
                        }
                    }
                    return newInputs
                })
                
                // Auto-select first category if available
                if (mappedCategories.length > 0 && mappedCategories[0].value) {
                    updatedFormValue.kategori_berita_id = mappedCategories[0].value
                }
            }
        }

        setFormValue(updatedFormValue)
    }
    
    // const handleDelete = async (id: any) => {
    //     try {
    //         if (window.confirm('Yakin ingin menghapus Berita COP?')) {
    //             setLoading(true)
    //             await MasterServices.deleteCOPNews(id)
    //             toast.success(`Berita Berhasil Dihapus`)
    //             refresh()
    //         }
    //     } catch (error) {
    //     }
    // }
    
    const onSubmit = async (e: any) => {
        e.preventDefault()

        try {
            setSubmit(true)

            const formData = new FormData()

            if (formValue.is_active === undefined) {
                formValue.is_active = '0'
            }

            if (formValue.is_highlight === undefined) {
                formValue.is_highlight = '0'
            }

            if (formValue.kategori_berita_id === undefined) {
                formValue.kategori_berita_id = ''
            }

            // Set default values for is_berita and is_blog if not set
            if (formValue.is_berita === undefined) {
                formValue.is_berita = '0'
            }
            if (formValue.is_blog === undefined) {
                formValue.is_blog = '0'
            }

            const id = formValue.id

            Object.keys(formValue).forEach(key => {
                if (key === 'id') {
                    // Don't include id in formData
                    return;
                } else if (key === 'upload_thumbnail' || key === 'upload_dokumen') {
                    // Check if upload_thumbnail is a File object
                    if (formValue[key] instanceof File) {
                        // It's a file, add it to formData
                        formData.append(key, formValue[key]);
                    } else if (typeof formValue[key] === 'string' && formValue[key].trim() !== '') {
                        // It's a string URL from an existing record - skip it
                        return
                    } else {
                        // Empty or null value
                        formData.append(key, '')
                    }
                } else {
                    formData.append(key, formValue[key])
                }
            })

            if (id) {
                await MasterServices.updateCOPNews(id, formData)
            } else {
                await MasterServices.storeCOPNews(formData)
            }

            toast.success(`Berhasil ${id ? 'Memperbarui' : 'Membuat'} Berita`)
            toggle()
            refresh()
        } catch (error) {
            console.error(error)
        } finally {
            setSubmit(false)
        }
    }

    const formatDate = (dateString: string) => {
        if (!dateString) return '-';
        
        const date = new Date(dateString);
        
        // Check if date is valid
        if (isNaN(date.getTime())) return dateString;
        
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        
        return `${day}-${month}-${year}`;
    }

    return (
        <div className='row'>
            <Modal show={show} onHide={toggle} size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title>{isEdit ? 'Form' : 'Form'} Berita</Modal.Title>
                </Modal.Header>
                <Form onSubmit={onSubmit}>
                    <Modal.Body>
                        <Row>{FormGenerator(inputFields, formValue, onChange)}</Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant='secondary' onClick={toggle} disabled={submit}>
                            Batalkan
                        </Button>
                        <Button variant='primary' type='submit' disabled={submit}>
                            {submit ? 'Loading' : 'Simpan'}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            <div className='col-md-12'>
                <div className='card-custom' style={{paddingBottom: '80px'}}>
                    <Row>
                        <Col md={{span: 4}}>
                            <Form.Control
                                placeholder='Cari...'
                                name='q'
                                onChange={(e) => setQuery({...query, q: e.target.value})}
                            />
                        </Col>
                        <Col md={{span: 2, offset: 4}}>
                            <Button
                                type='button'
                                onClick={() => {
                                    setFormValue({})
                                    toggle()
                                }}
                                className='form-control'
                            >
                                {'  '}+ Tambah
                            </Button>
                        </Col>
                        <Col md={{span: 2}}>
                            <Form.Select
                                aria-label='Default select example'
                                className='mr-8'
                                onChange={(e) => {
                                    setQuery({...query, sort_order: e.target.value})
                                }}
                            >
                                <option value='desc'>Terbaru</option>
                                <option value='asc'>Terlama</option>
                            </Form.Select>
                        </Col>
                    </Row>{' '}
                    <Row md={12} className='mt-8'>
                        <Table responsive className='table-striped align-middle'>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    {heads.map((item, index) => (
                                        <th key={index} style={{maxWidth: item.label == 'Aksi' ? '100px' : ''}}>
                                            {item.label}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {data.data?.data?.length === 0 && !loading && (
                                    <tr>
                                        <td colSpan={5} align='center'>
                                            Tidak ada Data
                                        </td>
                                    </tr>
                                )}

                                {loading ? (
                                    <tr>
                                        <td colSpan={5} align='center'>
                                            <Spinner
                                                animation='border'
                                                role='status'
                                                style={{height: '100px', width: '100px'}}
                                            />
                                        </td>
                                    </tr>
                                ) : (
                                    data.data?.data?.map((item: any, key: any) => {
                                        return (
                                            <tr key={key}>
                                                <td>{key + 1}</td>
                                                <td>{item.judul}</td>
                                                <td>{item.is_berita === '1' || item.is_berita === 1 || item.is_berita === true ? 'Berita' : 'CoP'}</td>
                                                <td>{item?.kategori?.nama_kategori || '-'}</td>
                                                <td>{formatDate(item.updated_at ?? item.created_at)}</td>
                                                <td>
                                                    {item.is_active == '0' ? (
                                                        <Button
                                                            variant='secondary'
                                                            className='shadow-none btn-sm btn-sm btn-outline btn-outline-dark'
                                                        >
                                                            Non-Aktif
                                                        </Button>
                                                    ) : (
                                                        <Button
                                                            className='shadow-none btn btn-sm btn-outline btn-outline-success'
                                                            variant='outline'
                                                        >
                                                            Aktif
                                                        </Button>
                                                    )}
                                                </td>
                                                <td>
                                                    <Button
                                                        onClick={async () => {
                                                            // Determine type based on is_berita and is_blog values
                                                            let typeValue = ''
                                                            if (item.is_berita === '1' || item.is_berita === 1 || item.is_berita === true) {
                                                                typeValue = 'Berita'
                                                            } else if (item.is_blog === '1' || item.is_blog === 1 || item.is_blog === true) {
                                                                typeValue = 'COP'
                                                            }

                                                            const categoriesBerita = await MasterServices.getCOPCategoryNoHash({tipe_kategori: typeValue})
                                                            const mappedCategories = categoriesBerita?.data?.data?.map((category: any) => ({
                                                                name: `${category.tipe_kategori} - ${category.nama_kategori}`,
                                                                value: category.id
                                                            })) || []

                                                            setInputFields(prevInputs => {
                                                                const newInputs = [...prevInputs]
                                                                const categoryIndex = newInputs.findIndex(input => input.name === 'kategori_berita_id')
                                                                if (categoryIndex !== -1) {
                                                                    // clear options
                                                                    newInputs[categoryIndex].options = []
                                                                    newInputs[categoryIndex] = {
                                                                        ...newInputs[categoryIndex],
                                                                        options: mappedCategories
                                                                    }
                                                                }
                                                                return newInputs
                                                            })

                                                            setFormValue({
                                                                id: item.id,
                                                                judul: item.judul,
                                                                kategori_berita_id: item.kategori_berita_id,
                                                                upload_thumbnail: item.upload_thumbnail,
                                                                upload_dokumen: item.upload_dokumen,
                                                                abstrak: item.abstrak,
                                                                link_youtube: item.link_youtube,
                                                                is_active: item.is_active === true ? '1' : '0',
                                                                urutan: item.urutan,
                                                                is_highlight: item.is_highlight === true ? '1' : '0',
                                                                Tipe: typeValue,
                                                                is_berita: item.is_berita === true ? '1' : '0',
                                                                is_blog: item.is_blog === true ? '1' : '0',
                                                            })
                                                            toggle()
                                                        }}
                                                        className='btn-sm'
                                                    >
                                                        Edit
                                                    </Button>
                                                </td>
                                            </tr>
                                        )
                                    })
                                )}
                            </tbody>
                        </Table>
                    </Row>
                    <Row>
                        <Col md={6}>
                            {data?.data?.data?.length > 0 && !loading && (
                            <div style={{float: 'left'}}>
                                <Dropdown>
                                    <Dropdown.Toggle className='btn btn-sm'>
                                        {pagination.per_page}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        {[10, 25, 50, 100].map((item: any) => (
                                        <Dropdown.Item
                                            key={item}
                                            href='#/action-1'
                                            onClick={() => onChangePerPage(item)}
                                            disabled={pagination.per_page === item}
                                        >
                                            {item}
                                        </Dropdown.Item>
                                        ))}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                            )}
                        </Col>
                        <Col md={6}>
                            <div style={{float: 'right'}}>
                                {!loading && (
                                    <Pagination className='btn-sm'>
                                        {paginator?.map((item: any) => {
                                            return (
                                            <Pagination.Item
                                                className='btn-sm'
                                                key={item}
                                                active={item === pagination.page}
                                                onClick={() => onChangePerPage(pagination.per_page, item)}
                                                disabled={item === '...'}
                                            >
                                                {item}
                                            </Pagination.Item>
                                            )
                                        })}
                                    </Pagination>
                                )}
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    )
}

const COPBerita: FC = () => (
    <>
        <PageTitle
            breadcrumbs={[
            {
                title: 'CoP',
                path: '/cop-dashboard',
                isSeparator: false,
                isActive: false,
            },
            {
                title: '/',
                path: '',
                isSeparator: false,
                isActive: false,
            },
            ]}
        >
            List Berita
        </PageTitle>
        <COPNewsPage />
    </>
)

export default COPBerita